// Chakra imports
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import routes from 'routes.js';
import ForexForm from 'views/mainpages/admin/forex/ForexForm';
import ForexView from 'views/mainpages/admin/forex/ForexView';
import GicForm from 'views/mainpages/admin/gic/GicForm';
import GicView from 'views/mainpages/admin/gic/GicView';
import UserDetailPage from 'views/mainpages/admin/main/components/UserDetailPage';
import EnquiryView from 'views/mainpages/admin/enquiry/EnquiryView';

// OSHC imports
import AdminOshcView from 'views/mainpages/admin/oshc/AdminOshcView';
import AdminOshcForm from 'views/mainpages/admin/oshc/AdminOshcForm';

// Student Funding imports
import AdminStudentFundingView from 'views/mainpages/admin/studentFunding/AdminStudentFundingView';
import AdminStudentFundingForm from 'views/mainpages/admin/studentFunding/AdminStudentFundingForm';

// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  const location = useLocation(); // To detect route changes
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [activeRoute, setActiveRoute] = useState('Default Brand Text');
  const [activeNavbar, setActiveNavbar] = useState(false);
  const [activeNavbarText, setActiveNavbarText] = useState('');

  // Update state on route change
  useEffect(() => {
    setActiveRoute(getActiveRoute(routes));
    setActiveNavbar(getActiveNavbar(routes));
    setActiveNavbarText(getActiveNavbarText(routes));
  }, [location.pathname, routes]); // Re-run whenever the location or routes change


  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    if (activeRoute === 'Default Brand Text') {
      return <Navigate to="/admin/default" replace />;
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };

  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };

  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === '/admin') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };

  const { onOpen } = useDisclosure();


  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={routes} display="none" {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'abroad educares'}
                  brandText={activeRoute}
                  secondary={activeNavbar}
                  message={activeNavbarText}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            <Box
              mx="auto"
              p={{ base: '20px', md: '30px' }}
              pe="20px"
              minH="100vh"
              pt={{ base: '200px', md: '130px', xl: '130px' }}
            >
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={<Navigate to="/admin/default" replace />}
                />
                <Route
                  path="/agent/userdetail/:id"
                  element={<UserDetailPage />}
                />
                <Route
                path='/gic/form'
                element={<GicForm />}
                />
                <Route 
                path='/forex/form'
                element={<ForexForm />}
                />
                <Route 
                path='/gic/:id'
                element={<GicView />}
                />
                <Route 
                path='/forex/:id'
                element={<ForexView />}
                />
                <Route 
                path='/enquiry/:id'
                element={<EnquiryView />}
                />
                <Route 
                path='/oshc/view/:id'
                element={<AdminOshcView />}
                />
                <Route 
                path='/oshc/add'
                element={<AdminOshcForm />}
                />
                <Route 
                path='/oshc/edit/:id'
                element={<AdminOshcForm />}
                />
                <Route 
                path='/student-funding/view/:id'
                element={<AdminStudentFundingView />}
                />
                <Route 
                path='/student-funding/add'
                element={<AdminStudentFundingForm />}
                />
                <Route 
                path='/student-funding/edit/:id'
                element={<AdminStudentFundingForm />}
                />

              </Routes>
            </Box>
            <Box></Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
